import { render, staticRenderFns } from "./Playground.vue?vue&type=template&id=cdb2b3dc&scoped=true&"
import script from "./Playground.vue?vue&type=script&lang=ts&"
export * from "./Playground.vue?vue&type=script&lang=ts&"
import style0 from "./Playground.vue?vue&type=style&index=0&id=cdb2b3dc&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb2b3dc",
  null
  
)

export default component.exports